import React from 'react'

function ChatRightMe(props) {
    return (

        <div className="chatrightrow">
            <div className="mychat">
                <p>{props.body}</p>
                <small>{props.time}</small>
            </div>
        </div>

    )
}

export default ChatRightMe